import { createContext } from 'react'
import type { ConfirmFn } from 'sutra/components/confirm/confirm-types'

export const ConfirmContext = createContext<ConfirmFn | null>(null)
